import Clickable from 'components/Common/Clickable'
import LineInfoCircleIcon from 'LuxKit/Icons/line/LineInfoCircleIcon'
import LineShieldCheckIcon from 'LuxKit/Icons/line/LineShieldCheckIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import ModalContext from 'contexts/ModalContext'
import { rem } from 'polished'
import { useContext, useMemo } from 'react'
import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import ExperienceCancellationPolicyModal from './ExperienceCancellationPolicyModal'
import useTrackExperienceOfferEvent from 'contexts/support/useTrackExperienceOfferEvent'

const IconText = styled(Clickable)`
  display: inline-flex;
  align-items: center;
  gap: ${rem(4)};
`

interface Props {
  onClick?: (e: React.MouseEvent<HTMLButtonElement>) => void;
  cancellationInfo?: App.ExperienceItemCancellationInfo;
  className?: string;
  date?: string;
  onSupportEmailClick?: () => void;
  onSupportNumberClick?: () => void;
  textSize?: 'small' | 'medium';
}

function ExperienceCancellationText(props: Props) {
  const {
    cancellationInfo,
    onClick,
    className,
    date,
    onSupportEmailClick,
    onSupportNumberClick,
    textSize = 'medium',
  } = props
  const intl = useIntl()
  const trackEvent = useTrackExperienceOfferEvent()

  const showModal = useContext(ModalContext)
  const hasFullRefund = useMemo(
    () =>
      cancellationInfo?.refundPolicies?.some((policy) => policy.value === 100),
    [cancellationInfo],
  )
  const onTextClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    e.preventDefault()
    showModal(
      <ExperienceCancellationPolicyModal
        cancellationInfo={cancellationInfo}
        date={date}
        onSupportEmailClick={onSupportEmailClick}
        onSupportNumberClick={onSupportNumberClick}
      />,
    )
    onClick?.(e)
    trackEvent('CANCELLATION_POLICY_CLICKED')
  }

  if (!cancellationInfo?.refundPolicies?.length) {
    return null
  }

  return (
    <IconText onClick={onTextClick} className={className}>
      <LineShieldCheckIcon
        colour="highlight-primary-dark"
        size={textSize === 'small' ? 'XS' : 'S'}
      />
      <BodyText colour="highlight-primary-dark" variant={textSize} weight="bold">
        {hasFullRefund &&
          intl.formatMessage({
            id: 'gnc42bYCUYEC1VtZ_FBb',
            defaultMessage: 'Free cancellation',
            description:
              'Form field label for free cancellation policy on experience',
          })}
        {!hasFullRefund &&
          intl.formatMessage({
            id: 'bTw_DeMR_qunnEGU5T4l',
            defaultMessage: 'Flexible cancellation',
            description: 'Label for flexible cancellation policy on experience',
          })}
      </BodyText>
      <LineInfoCircleIcon
        colour="normal-contrast"
        size={textSize === 'small' ? 'XS' : 'S'}
      />
    </IconText>
  )
}

export default ExperienceCancellationText
